module.exports = __webpack_public_path__ + "img/1140x624.c9c30265.png";